import { render, staticRenderFns } from "./login.vue?vue&type=template&id=1a1c3a62&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=1a1c3a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c3a62",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/alibabaAuth/login.vue
// module id = null
// module chunks = 